export const FETCH_MODEL = {
  init: 'pageModel/FETCH_MODEL/init',
  setModelState: 'pageModel/FETCH_MODEL/setModelState',
  request: 'pageModel/FETCH_MODEL/request',
  success: 'pageModel/FETCH_MODEL/success',
  failure: 'pageModel/FETCH_MODEL/failure',
  failureStatus: 'pageModel/FETCH_MODEL/failureStatus',
  cancel: 'pageModel/FETCH_MODEL/cancel',
} as const;

export const MODEL_JSON_STORE_NAME = 'modelJson' as const;

export const MODEL_RESET = 'pageModel/RESET' as const;

export const PROEKTIROVANIE_LINK = '/uslugi/proektirovanie-i-dizayn/';
export const RESHENIYA_LINK = '/uslugi/gotovye-resheniya-pod-klyuch/';
